<div class="flex-column">
    <span class="headline-1 pls-4 mbs-5 border-left text-primary-darker-title">
        {{ 'Gestión del caso' | uppercase }}
    </span>
        <mat-card  class="flex-100 pt-1">
            <div class="flex-column ml-4 flex-90">

                <form [formGroup]="this.formCaseManagement">

                    <span class="subtitle-3 text-primary-darker-h3">
                        Operador *
                    </span>
                    <app-operator-select [name]="this.OPERATOR" [form]="this.formCaseManagement"
                        [placeholder]="'Seleccione un operador'" [elements]="this.operators"
                        [defaultValue]="" [calculateId]="this.calculateIdOperator"
                        [calculateName]="this.calculateNameOperator" [placeholderSearching]="'Buscar operador...'"
                        [placeholderNoValue]="'No hay resultados'" [nameSearching]="this.OPERATOR_SEARCHING">
                    </app-operator-select>

                    <span class="subtitle-3 text-primary-darker-h3">
                        Agregar nota
                    </span>
                    <app-text-area-input class="notes" [name]="this.NOTE" [form]="this.formCaseManagement"
                        [placeholder]="'Escriba aqui'">
                    </app-text-area-input>
                    <div class="flex-row align-start-center flex-100"
                    style="z-index: 1; position: relative;top: -10px; height: fit-content; ">
                    <app-checkbox-input class="flex-8" [form]="this.formCaseManagement" [label]="'Critica'"
                        [labelPosition]="'before'" [name]="this.NOTE_CRITICAL"></app-checkbox-input>
                    <span *ngIf="this.formCaseManagement.get(this.NOTE_CRITICAL).value" class="flex-"
                        style="font-size: 10px; text-align:left; color: red">
                        <i>“Al marcarla como crítica, se generará una tarea y se enviará un mail al operador del
                            caso.”</i>
                    </span>
                </div>
                </form>
            </div>
        </mat-card>
</div>
